import { IAPI } from '../../lib/models/api';
import { loan_application_lender_tier } from '@axo/shared/data-access/types';

export function getLenderTier({ url: { service: baseURL }, token }: IAPI) {
  return async (
    loanApplicationId: string
  ): Promise<loan_application_lender_tier.LoanApplicationLenderTier | null> => {
    const url = new URL(
      `/loan-application-lender-tier/${loanApplicationId}`,
      baseURL
    );
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });

    const responseJson = await response.json();

    if (response.ok) return responseJson;
    if (response.status === 404) return null;
    throw new Error(
      `Error fetching ${response.url}: ${response.status} ${
        response.statusText
      } ${responseJson.error || responseJson.message}`
    );
  };
}
